import { Bell } from 'lucide-react'
import { H3 } from '@/components/sv/typographies'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

export const UsageAlertCardFallback = () => (
  <Card className="bg-secondary p-0 gap-0">
    <CardHeader className="px-5 py-3 flex flex-row items-center justify-between gap-0">
      <CardTitle>
        <H3 className="flex items-center gap-2 text-sm text-muted-foreground">
          <Bell className="size-4" /> Usage alert
        </H3>
      </CardTitle>
    </CardHeader>
    <CardContent className="p-0">
      <Card className="p-0 border-x-0 border-b-0 shadow-none">
        <CardContent className="p-4 space-y-4">
          <div className="flex items-start justify-between gap-4">
            <div className="space-y-2">
              <Skeleton className="h-4 w-32" />
              <Skeleton className="h-7 w-48" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-9 w-24" />
              <Skeleton className="h-9 w-24" />
            </div>
          </div>
          <Skeleton className="h-2 w-full" />
          <Skeleton className="h-4 w-40" />
          <Skeleton className="h-12 w-full" />
          <Skeleton className="h-12 w-full" />
        </CardContent>
      </Card>
    </CardContent>
  </Card>
)
